import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { filter, map } from 'rxjs/operators';

export interface IMassageEvent<T> {
  type: string;
  payload: T;
}

type MessageCallback<T> = (payload: T) => void;

@Injectable({
  providedIn: 'root',
})
export class EventService {
  private handler = new Subject<IMassageEvent<any>>();

  broadcast<T>(type: string, payload: T) {
    this.handler.next({ type, payload });
  }

  on<T>(type: string): Observable<T> {
    return this.handler
      .pipe(
        filter(message => message.type === type),
        map(message => message.payload),
      );
  }
}
